import { render, staticRenderFns } from "./DetailUssd.vue?vue&type=template&id=921a863c&scoped=true&"
import script from "./DetailUssd.vue?vue&type=script&lang=js&"
export * from "./DetailUssd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921a863c",
  null
  
)

export default component.exports